import script from "./SuperPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuperPage.vue?vue&type=script&lang=ts&setup=true"

import "./SuperPage.vue?vue&type=style&index=0&id=5f85d592&scope=true&lang=css"

const __exports__ = script;

export default __exports__